import { render, staticRenderFns } from "./AiConsultingSection.vue?vue&type=template&id=5dc8a31e&scoped=true"
import script from "./AiConsultingSection.vue?vue&type=script&lang=js"
export * from "./AiConsultingSection.vue?vue&type=script&lang=js"
import style0 from "./AiConsultingSection.vue?vue&type=style&index=0&id=5dc8a31e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc8a31e",
  null
  
)

export default component.exports